var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { LoginType } from '@lucidlink/dto/validation';
import { useAuthProvider } from '#context';
export const NoCodeLoginRoute = ({ children, }) => {
    _react_refresh_temp_2();
    const { currentUser } = useAuthProvider();
    if (currentUser?.loginType &&
        currentUser.loginType !== LoginType.VERIFICATION_CODE) {
        return children;
    }
    return _jsx(Navigate, { to: "/workspace" });
};
_react_refresh_temp_1 = NoCodeLoginRoute;
$RefreshReg$(_react_refresh_temp_1, "NoCodeLoginRoute");
_react_refresh_temp_2(NoCodeLoginRoute, "b0WOwRgVIKrHfkYSRIu+XLATATo=", false, () => [useAuthProvider]);
